import React from 'react';
import PropTypes from 'prop-types';

import {formatURLDomain, isScriptUrl, isFullUrl} from '@stubhub/sh-url-utils';

import './index.scss';

const FormattedLink = ({
  locale,
  href,
  children,
  LinkComp,
  externalLink = false,
  linkRef,
  defaultLocale,
  currentLocale,
  matchRoutes,
  ...otherProps
}) => {
  if (!href || isScriptUrl(href)) {
    return (
      <button
        type="button"
        {...otherProps}
        className={`${otherProps.className || ''} formatted-link__button-as-link`}
        ref={linkRef}
      >
        {children}
      </button>
    );
  }

  if (externalLink) {
    return (
      <a href={href} {...otherProps} ref={linkRef}>
        {children}
      </a>
    );
  }

  const fullHref = formatURLDomain({href, locale, defaultLocale, currentLocale});

  if (isFullUrl(fullHref) || !matchRoutes || !matchRoutes(fullHref)) {
    return (
      <a href={fullHref} {...otherProps} ref={linkRef}>
        {children}
      </a>
    );
  }

  return (
    <LinkComp to={fullHref} href={fullHref} {...otherProps} ref={linkRef}>
      {children}
    </LinkComp>
  );
};

FormattedLink.propTypes = {
  /** Site default locale */
  defaultLocale: PropTypes.string,

  /** Current user locale */
  currentLocale: PropTypes.string,

  /** Children node */
  children: PropTypes.node,

  /** Is this a external link? */
  externalLink: PropTypes.bool,

  /** Href for the link */
  href: PropTypes.string,

  /** Link component to use if it's not an external link*/
  LinkComp: PropTypes.elementType,

  /** Ref to assign to the link */
  linkRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({current: PropTypes.any})]),

  /** Custom locale */
  locale: PropTypes.string,

  /** Function to check if the route matches the app. */
  matchRoutes: PropTypes.func,
};

export default FormattedLink;
